/* eslint-disable */

import instance from './frontman';

export const getBanner = async (
    accessToken?: String,
    options?: { skipMaintenanceRedirect?: boolean; timeout?: number }
) => {
    return await instance({
        url: "/banner",
        method: "get",
        ...options
    })
};
